import { apolloClient } from "@/plugins/vue-apollo.js";

const getPaymentStatus = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/bookings/api/mutations/payment_status.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/bookings/api/queries/booking_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allBookings = store.readQuery(query);
        store.writeQuery({
          ...query,
            data: allBookings,
            status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { getPaymentStatus };
